(function (fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    document.addEventListener('focusin', (e) => {
        if (e.target.form && e.target.form.classList.contains('form-book-a-demo')) {
            const parent = e.target.offsetParent;
            parent.classList.add('selected');
        }
    });
    document.addEventListener('focusout', (e) => {
        const parent = e.target.offsetParent;
        if (e.target.form && e.target.form.classList.contains('form-book-a-demo')) {
            parent.classList.remove('selected');
            if (e.target.value) {
                parent.classList.add('not-empty');
            }
            if (!e.target.value) {
                parent.classList.remove('not-empty');
            }
        }
    });
}));
